import validFileNumber from '../libraries/valid-file-number'
import commentLoad from '../libraries/comment-load'
import commentPost from '../libraries/comment-post'
import corporateSearch from '../libraries/corporate-search'
import parentStoreLoad from '../libraries/parent-store-load'
import agencyLoad from '../libraries/agency-load'
import AmountFormatter from '../libraries/amount-formatter'
import Vue from 'vue'
import bankAccountEditVue from '../components/store_examinations/bank-account.vue'
import corporateNumberEditVue from '../components/store_examinations/corporate-number.vue'

export default {

  index() {
    document.addEventListener('DOMContentLoaded', () => {
      Array.from(document.getElementsByClassName('store_ids_all')).forEach(el => {
        el.addEventListener('change', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          check_elements.forEach(check_element => {
            check_element.checked = el.checked
          })
        })
      })

      Array.from(document.getElementsByName('agency_name'))[0].disabled = document.getElementById('agency_blank_search').checked;
      document.getElementById('agency_blank_search').addEventListener('change', (e) => {
        Array.from(document.getElementsByName('agency_name'))[0].disabled = document.getElementById('agency_blank_search').checked;
      })

      Array.from(document.getElementsByName('parent_store_name'))[0].disabled = document.getElementById('parent_store_blank_search').checked;
      document.getElementById('parent_store_blank_search').addEventListener('change', (e) => {
        Array.from(document.getElementsByName('parent_store_name'))[0].disabled = document.getElementById('parent_store_blank_search').checked;
      })

      Array.from(document.getElementsByName('search_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const form_element = el.parentNode.parentNode
          form_element.action = '/manage/store_examinations'
          form_element.submit()
        })
      })
      Array.from(document.getElementsByName('g2_global_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/store_examinations/g2_global'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByName('g2_pmm_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const form_element = el.parentNode.parentNode
          form_element.action = '/manage/store_examinations/g2_pmm'
          form_element.submit()
        })
      })
      Array.from(document.getElementsByName('orico_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/dental_examinations/orico_dental_list'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByClassName('jaccs_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode.parentNode.parentNode
            const hidden_element = document.createElement("input")
            hidden_element.setAttribute("type", "hidden")
            hidden_element.setAttribute("name", "mode")
            hidden_element.setAttribute("value", el.dataset.mode)
            form_element.appendChild(hidden_element)
            form_element.action = "/manage/dental_examinations/jaccs_dental_list"
            form_element.submit()
            form_element.removeChild(hidden_element)
          }
        })
      })
      Array.from(document.getElementsByClassName("nicos_btn")).forEach(el => {
        el.addEventListener("click", (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode.parentNode.parentNode
            const hidden_element = document.createElement("input")
            hidden_element.setAttribute("type", "hidden")
            hidden_element.setAttribute("name", "mode")
            hidden_element.setAttribute("value", el.dataset.mode)
            form_element.appendChild(hidden_element)
            form_element.action = "/manage/dental_examinations/nicos_dental_list"
            form_element.submit()
            form_element.removeChild(hidden_element)
          }
        })
      })
      Array.from(document.getElementsByName('resona_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/dental_examinations/resona_dental_list'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByName('common_acquirer_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/store_examinations/common_acquirer_list'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByName('jdm_inquiry_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/store_examinations/jdm_inquiry_list'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByName('csrs2_inquiry_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/store_examinations/csrs2_inquiry_list'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByClassName('jcb_ec_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert('対象の加盟店が選択されていません')
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode.parentNode.parentNode
            const hidden_element = document.createElement('input')
            hidden_element.setAttribute('type', 'hidden')
            hidden_element.setAttribute('name', 'mode')
            hidden_element.setAttribute('value', el.dataset.mode)
            form_element.appendChild(hidden_element)
            form_element.action = '/manage/store_examinations/jcb_ec_list'
            form_element.submit()
            form_element.removeChild(hidden_element)
          }
        })
      })
      Array.from(document.getElementsByClassName('jcb_shop_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert('対象の加盟店が選択されていません')
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode.parentNode.parentNode
            const hidden_element = document.createElement('input')
            hidden_element.setAttribute('type', 'hidden')
            hidden_element.setAttribute('name', 'mode')
            hidden_element.setAttribute('value', el.dataset.mode)
            form_element.appendChild(hidden_element)
            form_element.action = '/manage/dental_examinations/jcb_shop_list'
            form_element.submit()
            form_element.removeChild(hidden_element)
          }
        })
      })
      Array.from(document.getElementsByClassName("paypay-btn")).forEach(el => {
        el.addEventListener("click", (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode.parentNode.parentNode
            const hidden_element = document.createElement("input")
            hidden_element.setAttribute("type", "hidden")
            hidden_element.setAttribute("name", "mode")
            hidden_element.setAttribute("value", el.dataset.mode)
            form_element.appendChild(hidden_element)
            form_element.action = "/manage/store_examinations/paypay_list"
            form_element.submit()
            form_element.removeChild(hidden_element)
          }
        })
      })
      Array.from(document.getElementsByClassName('sbps_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode.parentNode.parentNode
            const hidden_element = document.createElement("input")
            hidden_element.setAttribute("type", "hidden")
            hidden_element.setAttribute("name", "mode")
            hidden_element.setAttribute("value", el.dataset.mode)
            form_element.appendChild(hidden_element)
            form_element.action = "/manage/store_examinations/sbps_list"
            form_element.submit()
            form_element.removeChild(hidden_element)
          }
        })
      })
      Array.from(document.getElementsByName('payeasy_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/store_examinations/payeasy_common_list'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByName('sbps_smcc_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/store_examinations/sbps_smcc_list'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByClassName('smcc_dental_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode.parentNode.parentNode
            const hidden_element = document.createElement("input")
            hidden_element.setAttribute("type", "hidden")
            hidden_element.setAttribute("name", "mode")
            hidden_element.setAttribute("value", el.dataset.mode)
            form_element.appendChild(hidden_element)
            form_element.action = "/manage/dental_examinations/smcc_dental"
            form_element.submit()
            form_element.removeChild(hidden_element)
          }
        })
      })
      Array.from(document.getElementsByName('ntt_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/dental_examinations/ntt_list'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByName('jcn_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/dental_examinations/jcn_list'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByName('gmo_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/dental_examinations/gmo_list'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByName('pa_sync_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/store_examinations/update_pa_sync'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByName('transcribe_btn')).forEach(el => {
        el.addEventListener('click', (e) => {
          const check_elements = Array.from(document.getElementsByName('store_ids[]'))
          const checked = check_elements.some(check_element => {
            return check_element.checked === true
          })
          if (!checked) {
            alert("対象の加盟店が選択されていません")
            e.preventDefault()
          } else {
            const form_element = el.parentNode.parentNode
            form_element.action = '/manage/store_examinations/transcribe_stores'
            form_element.submit()
          }
        })
      })
      Array.from(document.getElementsByName('pl_stores_csv')).forEach(el => {
        el.addEventListener('click', (e) => {
          const form_element = el.parentNode.parentNode
          form_element.action = '/manage/pay_light/list'
          form_element.submit()
        })
      })
      Array.from(document.getElementsByClassName('th-sortable')).forEach(el => {
        const form = document.forms[0];
        const order_by_created_at = form['order_by_created_at'];
        const i = el.firstElementChild;
        const col = el.dataset.thSortableCol;
        el.addEventListener('click', (e) => {
          if(col === 'created_at') {
            if(order_by_created_at.value === 'desc') {
              order_by_created_at.value = 'asc';
            } else {
              order_by_created_at.value = 'desc';
            }
          }
          form.submit();
        }, false);
        if(order_by_created_at.value === 'desc') {
          i.textContent = 'arrow_drop_up';
        } else {
          i.textContent = 'arrow_drop_down';
        }
      })
    })
  },

  edit() {
    const script = document.createElement('script')
    script.src = "https://ajaxzip3.github.io/ajaxzip3.js"
    document.head.appendChild(script)

    window.card_company_select_limit = function () {
      let selected_value = []
      Array.from(document.getElementsByClassName('card_company_select')).forEach(el => {
        if (el.value === "") return
        const displayEl = el.parentNode.parentNode.parentNode
        if (document.defaultView.getComputedStyle(displayEl,null).display === "none") return
        selected_value.push(el.value)
      })
      Array.from(document.getElementsByClassName('card_company_select')).forEach(el => {
        Array.from(el.getElementsByTagName("option")).forEach(option => {
          if(option.value === "") return
          if(option.value === el.value) return
          if (selected_value.length === 0) option.disabled = false
          else option.disabled = selected_value.includes(option.value);
          if (option.selected && option.disabled) option.selected = false
        })
      })
    };

    window.e_money_company_select_limit = function () {
      let selected_value = []
      Array.from(document.getElementsByClassName('e_money_company_select')).forEach(el => {
        if (el.value === "") return
        const displayEl = el.parentNode.parentNode.parentNode
        if (document.defaultView.getComputedStyle(displayEl,null).display === "none") return
        selected_value.push(el.value)
      })
      Array.from(document.getElementsByClassName('e_money_company_select')).forEach(el => {
        Array.from(el.getElementsByTagName("option")).forEach(option => {
          if(option.value === "") return
          if(option.value === el.value) return
          if (selected_value.length === 0) option.disabled = false
          else option.disabled = selected_value.includes(option.value);
          if (option.selected && option.disabled) option.selected = false
        })
      })
    };

    window.qr_code_company_select_limit = function () {
      let selected_value = []
      Array.from(document.getElementsByClassName('qr_code_company_select')).forEach(el => {
        if (el.value === "") return
        const displayEl = el.parentNode.parentNode.parentNode
        if (document.defaultView.getComputedStyle(displayEl,null).display === "none") return
        selected_value.push(el.value)
      })
      Array.from(document.getElementsByClassName('qr_code_company_select')).forEach(el => {
        Array.from(el.getElementsByTagName("option")).forEach(option => {
          if(option.value === "") return
          if(option.value === el.value) return
          if (selected_value.length === 0) option.disabled = false
          else option.disabled = selected_value.includes(option.value);
          if (option.selected && option.disabled) option.selected = false
        })
      })
    };

    window.direct_debit_company_select_limit = function () {
      let selected_value = []
      Array.from(document.getElementsByClassName('direct_debit_company_select')).forEach(el => {
        if (el.value === "") return
        const displayEl = el.parentNode.parentNode.parentNode
        if (document.defaultView.getComputedStyle(displayEl,null).display === "none") return
        selected_value.push(el.value)
      })
      Array.from(document.getElementsByClassName('direct_debit_company_select')).forEach(el => {
        Array.from(el.getElementsByTagName("option")).forEach(option => {
          if(option.value === "") return
          if(option.value === el.value) return
          if (selected_value.length === 0) option.disabled = false
          else option.disabled = selected_value.includes(option.value);
          if (option.selected && option.disabled) option.selected = false
        })
      })
    };

    window.set_parent_store = () => {
      let idValue = ""

      const idEl = document.getElementById("store_parent_store_id")
      const txtEl = document.getElementById("parent_store_text")
      const inputValue = txtEl.value
      const addNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#tag-box"]');
      const addeMoneyNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#e-money-destination-form"]');
      const addQrCodeNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#qr-code-destination-form"]');
      const addDirectDebitNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#direct_debit-destination-form"]');
      if (inputValue === "") {
        idEl.value = idValue
        Array.from(document.getElementsByClassName("parent_store_item")).forEach(element => {
          element.disabled = false
        });

        if(addNestedFieldsBtn != null) {
          addNestedFieldsBtn.classList.remove('d-none');
        }
        Array.from(document.getElementsByClassName("parent_store_card_company_nested_fields")).forEach(element => {
          if(element.querySelector('.parent_store_card_company') != null) {
              element.querySelector('.parent_store_card_company').disabled = false;
          }
          if(element.querySelector('.parent_store_ratio') != null) {
              element.querySelector('.parent_store_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_agency_sales_ratio') != null) {
              element.querySelector('.parent_store_agency_sales_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_wholesale_ratio') != null) {
              element.querySelector('.parent_store_wholesale_ratio').disabled = false;
          }
          if(element.querySelector('.d-none') != null) {
              element.querySelector('.d-none').classList.remove('d-none')
          }
        });

        if(addeMoneyNestedFieldsBtn != null) {
          addeMoneyNestedFieldsBtn.classList.remove('d-none');
        }
        Array.from(document.getElementsByClassName("parent_store_e_money_company_nested_fields")).forEach(element => {
          if(element.querySelector('.parent_store_e_money_company') != null) {
            element.querySelector('.parent_store_e_money_company').disabled = false;
          }
          if(element.querySelector('.parent_store_e_money_ratio') != null) {
            element.querySelector('.parent_store_e_money_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_e_money_agency_sales_ratio') != null) {
            element.querySelector('.parent_store_e_money_agency_sales_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_wholesale_ratio') != null) {
              element.querySelector('.parent_store_wholesale_ratio').disabled = false;
          }
          if(element.querySelector('.d-none') != null) {
            element.querySelector('.d-none').classList.remove('d-none')
          }
        });

        if(addQrCodeNestedFieldsBtn != null) {
          addQrCodeNestedFieldsBtn.classList.remove('d-none');
        }
        Array.from(document.getElementsByClassName("parent_store_qr_code_company_nested_fields")).forEach(element => {
          if(element.querySelector('.parent_store_qr_code_company') != null) {
            element.querySelector('.parent_store_qr_code_company').disabled = false;
          }
          if(element.querySelector('.parent_store_qr_code_ratio') != null) {
            element.querySelector('.parent_store_qr_code_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_qr_code_agency_sales_ratio') != null) {
            element.querySelector('.parent_store_qr_code_agency_sales_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_wholesale_ratio') != null) {
              element.querySelector('.parent_store_wholesale_ratio').disabled = false;
          }
          if(element.querySelector('.d-none') != null) {
            element.querySelector('.d-none').classList.remove('d-none')
          }
        });

        if(addDirectDebitNestedFieldsBtn != null) {
          addDirectDebitNestedFieldsBtn.classList.remove('d-none');
        }
        Array.from(document.getElementsByClassName("parent_store_direct_debit_company_nested_fields")).forEach(element => {
          if(element.querySelector('.parent_store_direct_debit_company') != null) {
            element.querySelector('.parent_store_direct_debit_company').disabled = false;
          }
          if(element.querySelector('.parent_store_direct_debit_ratio') != null) {
            element.querySelector('.parent_store_direct_debit_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_direct_debit_agency_sales_ratio') != null) {
            element.querySelector('.parent_store_direct_debit_agency_sales_ratio').disabled = false;
          }
          if(element.querySelector('.parent_store_wholesale_ratio') != null) {
              element.querySelector('.parent_store_wholesale_ratio').disabled = false;
          }
          if(element.querySelector('.d-none') != null) {
            element.querySelector('.d-none').classList.remove('d-none')
          }
        });

        return
      }

      const masterListEl = document.getElementById("parent_store_master_list")
      Array.from(masterListEl.getElementsByTagName("option")).forEach(option => {
        if(option.value == inputValue) idValue = option.innerText
      })
      if(idValue == "") txtEl.value = ""
      else {
        let token = ''
        Array.from(document.getElementsByTagName('meta')).forEach(meta => {
          if (meta.name != 'csrf-token') return
          token = meta.content
        })
        parentStoreLoad(idValue, token)
        Array.from(document.getElementsByClassName("parent_store_item")).forEach(element => {
          element.disabled = true
        });
        Array.from(document.getElementsByClassName("parent_store_brand")).forEach(element => {
          element.disabled = false
        });
        Array.from(document.getElementsByClassName("parent_store_e_money_brand")).forEach(element => {
          element.disabled = false
        });
        Array.from(document.getElementsByClassName("parent_store_qr_code_brand")).forEach(element => {
          element.disabled = false
        });
        Array.from(document.getElementsByClassName("parent_store_direct_debit_brand")).forEach(element => {
          element.disabled = false
        });
        if(addNestedFieldsBtn != null) {
          addNestedFieldsBtn.classList.add('d-none');
        }
        if(addeMoneyNestedFieldsBtn != null) {
          addeMoneyNestedFieldsBtn.classList.add('d-none');
        }
        if(addQrCodeNestedFieldsBtn != null) {
          addQrCodeNestedFieldsBtn.classList.add('d-none');
        }
        if(addDirectDebitNestedFieldsBtn != null) {
          addDirectDebitNestedFieldsBtn.classList.add('d-none');
        }
      }
      idEl.value = idValue
    };

    window.set_agency = () => {
      let idValue = ""
      const idEl = document.getElementById("store_agency_id")
      const agencyTxtEl = document.getElementById("agency_text")
      const agencyInputValue = agencyTxtEl.value
      const masterListEl = document.getElementById("agency_master_list")
      Array.from(masterListEl.getElementsByTagName("option")).forEach(option => {
        if(option.value == agencyInputValue) idValue = option.innerText
      })
      idEl.value = idValue
      if (idValue !== "") {
        let token = ''
        let parentStoreStatus = null

        Array.from(document.getElementsByTagName('meta')).forEach(meta => {
          if (meta.name != 'csrf-token') return
          token = meta.content
        })

        const parentStoreTxtEl = document.getElementById("parent_store_text")
        const parentStoreInputValue = parentStoreTxtEl.value
        if (parentStoreInputValue !== "") {
          parentStoreStatus = true
        } else {
          parentStoreStatus = false
        }

        agencyLoad(idValue, token, "store", parentStoreStatus, "change")
      } else if (idValue === "") {
        agencyTxtEl.value = ""
        if (document.getElementById("parent_store_text").value === "") {
          Array.from(document.getElementsByClassName("parent_store_card_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_brand').value = 0;
            element.querySelector('input[type="hidden"]').value = 1;
            element.style.display = 'none';
          });
          Array.from(document.getElementsByClassName("parent_store_e_money_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_e_money_brand').value = 0;
            element.querySelector('input[type="hidden"]').value = 1;
            element.style.display = 'none';
          });
          Array.from(document.getElementsByClassName("parent_store_qr_code_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_qr_code_brand').value = 0;
            element.querySelector('input[type="hidden"]').value = 1;
            element.style.display = 'none';
          });
          Array.from(document.getElementsByClassName("parent_store_direct_debit_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_direct_debit_brand').value = 0;
            element.querySelector('input[type="hidden"]').value = 1;
            element.style.display = 'none';
          });
        } else {
          Array.from(document.getElementsByClassName("parent_store_card_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_brand').value = 0;
          });
          Array.from(document.getElementsByClassName("parent_store_e_money_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_e_money_brand').value = 0;
          });
          Array.from(document.getElementsByClassName("parent_store_qr_code_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_e_money_brand').value = 0;
          });
          Array.from(document.getElementsByClassName("parent_store_direct_debit_company_nested_fields")).forEach(element => {
            element.querySelector('.parent_store_e_money_brand').value = 0;
          });
        }
      }
    };

    document.addEventListener('DOMContentLoaded', () => {

      new Vue({
        el: '#edit_corporate_number',
        render: h => h(corporateNumberEditVue)
      })

      // Vue コンポーネント内外で要素を相互参照していて気持ち悪いが、動きはするので良いことにする。
      corporateSearch.activate({
        corporateNumber: document.querySelector("#store_corporation_attributes_number"),
        name: document.querySelector("#store_corporation_attributes_name"),
        nameKana: document.querySelector("#store_corporation_attributes_name_kana"),
        postCode: document.querySelector("#store_corporation_attributes_zip_code"),
        prefecture: document.querySelector("#store_corporation_attributes_state"),
        city: document.querySelector("#store_corporation_attributes_city"),
        street: document.querySelector("#store_corporation_attributes_street"),
      })
      document.querySelector("#copy-corporate-search-results").addEventListener("click", corporateSearch.copyResultValuesToInput)

      new Vue({
        el: '#edit_bank_account',
        render: h => h(bankAccountEditVue)
      })

      const checkObjects = [
        {elementName: 'business_scheme_file', limitNumber: 5},
        {elementName: 'representative_auth_file', limitNumber: 3},
        {elementName: 'representative_other_file', limitNumber: 5},
        {elementName: 'ubo_auth_file', limitNumber: 5}
      ]

      checkObjects.forEach(checkObject => {
        Array.from(document.getElementsByClassName(checkObject.elementName)).forEach(el => {
          el.addEventListener('change', (e) => {
            validFileNumber(checkObject.limitNumber, e)
          })
        })
      })

      Array.from(document.getElementsByTagName('input')).forEach(element => {
        if (element.type != 'text') return
        element.addEventListener('keypress', () => {
          if (event.keyCode == 13) {
            event.preventDefault()
          }
        })
      })

      Array.from(document.getElementsByClassName("change-activation")).forEach(element => {
        const target = element.dataset.target
        const activate = element.dataset.activate === "true"

        // on-change
        element.addEventListener("change", () => {
          Array.from(document.getElementById(target).getElementsByTagName("select")).forEach(select => select.disabled = !activate)
        })

        // view-init
        element.checked && element.dispatchEvent(new Event("change", { "bubbles": false, "cancelable": true }))
      })

      Array.from(document.getElementsByClassName('zip-search-btn')).forEach(element => {
        element.addEventListener('click', () => {
          const zip_code = element.previousElementSibling
          const state = document.getElementsByName(zip_code.name.replace('[zip_code]', '[state]'))[0]
          const city = document.getElementsByName(zip_code.name.replace('[zip_code]', '[city]'))[0]
          const street = document.getElementsByName(zip_code.name.replace('[zip_code]', '[street]'))[0]
          AjaxZip3.zip2addr(zip_code, '', state.name, city.name, street.name)
        })
      })

      Array.from(document.getElementsByName('store[corporation_attributes][corporation_flg]')).forEach(el => {
        Array.from(document.getElementsByClassName('corporation_area')).forEach(area => {
          area.style.display = el.value === "true" ? "" : "none"
        })
        el.addEventListener('change', (e) => {
          document.getElementById('no_ubo').value = el.value === 'false'  // 個人の場合、uboのhidden情報も設定。
          Array.from(document.getElementsByClassName('corporation_area')).forEach(area => {
            area.style.display = el.value === "true" ? "" : "none"
          })
        })
      })

      Array.from(document.getElementsByClassName('ubo_is_representative')).forEach(el => {
        document.getElementById('ubo').style.display = el.checked == true ? "none" : ""
        document.getElementById('no_ubo').value = el.checked == true
        el.addEventListener('change', (e) => {
          document.getElementById('ubo').style.display = el.checked == true ? "none" : ""
          document.getElementById('no_ubo').value = el.checked == true
        })
      })

      Array.from(document.getElementsByName('store[agency_id]')).forEach(el => {
        if (el.value === "") {
          Array.from(document.getElementsByClassName('setting_bank_account')).forEach(setting => {
            setting.checked = true
            setting.disabled = "disabled"
            Array.from(document.getElementsByClassName('bank_account_area')).forEach(area => {
              area.style.display = ""
            })
          })
        }
        el.addEventListener('change', (e) => {
          if (el.value === "") {
            Array.from(document.getElementsByClassName('setting_bank_account')).forEach(setting => {
              setting.checked = true
              setting.disabled = "disabled"
              Array.from(document.getElementsByClassName('bank_account_area')).forEach(area => {
                area.style.display = ""
              })
            })
          } else {
            Array.from(document.getElementsByClassName('setting_bank_account')).forEach(setting => {
              setting.disabled = null
            })
          }
        })
      })

      Array.from(document.getElementsByName('store[agency_id]')).forEach(el => {
        if (el.value !== "") {
          let token = ''
          let parentStoreStatus = null

          Array.from(document.getElementsByTagName('meta')).forEach(meta => {
            if (meta.name != 'csrf-token') return
            token = meta.content
          })

          const txtEl = document.getElementById("parent_store_text")
          const inputValue = txtEl.value
          if (inputValue !== "") {
            parentStoreStatus = true
          } else {
            parentStoreStatus = false
          }

          agencyLoad(el.value, token, "store", parentStoreStatus, "load")
        }
      })

      Array.from(document.getElementsByClassName("parent_store_card_company_nested_fields")).forEach(element => {
        element.querySelector('.btn-delete').addEventListener('click', () => {
          element.querySelector('.parent_store_brand').value = 0;
        })
      })

      Array.from(document.getElementsByName('store[parent_store_id]')).forEach(el => {
        if (el.value !== "") {
          let token = ''
          Array.from(document.getElementsByTagName('meta')).forEach(meta => {
            if (meta.name != 'csrf-token') return
            token = meta.content
          })
          parentStoreLoad(el.value, token)
          Array.from(document.getElementsByClassName("parent_store_item")).forEach(element => {
            element.disabled = true
          });
          Array.from(document.getElementsByClassName("parent_store_brand")).forEach(element => {
            element.disabled = false
          });
          Array.from(document.getElementsByClassName("parent_store_e_money_brand")).forEach(element => {
            element.disabled = false
          });
          const addNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#tag-box"]');
          if(addNestedFieldsBtn != null) {
            addNestedFieldsBtn.classList.add('d-none');
          }
          const addeMoneyNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#e-money-destination-form"]');
          if(addeMoneyNestedFieldsBtn != null) {
            addeMoneyNestedFieldsBtn.classList.add('d-none');
          }
          const addQrCodeNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#qr-code-destination-form"]');
          if(addQrCodeNestedFieldsBtn != null) {
            addQrCodeNestedFieldsBtn.classList.add('d-none');
          }
          const addDirectDebitNestedFieldsBtn = document.querySelector('[data-association-insertion-node="#direct-debit-destination-form"]');
          if(addDirectDebitNestedFieldsBtn != null) {
            addDirectDebitNestedFieldsBtn.classList.add('d-none');
          }
        }
      })

      const industry_json = JSON.parse(document.getElementById("industry_json").value)
      function big_industry_select(el) {
        let industry_list = []
        for (let i = 0; i < industry_json.length; i++) {
          if (industry_json[i].big_industry_id !== parseInt(el.value)) continue
          industry_list.push(industry_json[i].id)
        }
        Array.from(document.getElementsByName('store[small_industry_id]')).forEach(iel => {
          Array.from(iel.getElementsByTagName("option")).forEach(option => {
            if(option.value === "") return
            if (industry_list.length === 0) option.disabled = false
            else option.disabled = !industry_list.includes(parseInt(option.value));
            if (option.selected && option.disabled) option.selected = false
          })
        })
      }

      function small_industry_select(el) {
        let big_industry_id = 0
        let mcc = ''
        for (let i = 0; i < industry_json.length; i++) {
          if (industry_json[i].id !== parseInt(el.value)) continue
          big_industry_id = industry_json[i].big_industry_id
          mcc = industry_json[i].mcc
          break
        }
        Array.from(document.getElementsByName('store[big_industry_id]')).forEach(iel => {
          Array.from(iel.getElementsByTagName("option")).forEach(option => {
            if(option.value === "") return
            if (big_industry_id === 0) option.disabled = false
            else option.disabled = big_industry_id !== parseInt(option.value);
            if (option.selected && option.disabled) option.selected = false
          })
        })
        Array.from(document.getElementsByName('mcc')).forEach(mel => {
          mel.value = mcc
        })
      }

      Array.from(document.getElementsByName('store[big_industry_id]')).forEach(el => {
        big_industry_select(el)
        el.addEventListener('change', (e) => {
          big_industry_select(el)
        })
      })

      Array.from(document.getElementsByName('store[small_industry_id]')).forEach(el => {
        small_industry_select(el)
        el.addEventListener('change', (e) => {
          small_industry_select(el)
        })
      })

      function payment_method_other_text_enable(el) {
        const other_text = document.getElementById('store_common_store_attributes_store_examination_attributes_payment_method_other_text')
        if (el.value === "" || parseInt(el.value) !== 4) {
          other_text.value = null
          other_text.readOnly = true
        } else {
          other_text.readOnly = false
        }
      }

      Array.from(document.getElementsByName('store[common_store_attributes][store_examination_attributes][payment_method]')).forEach(el => {
        payment_method_other_text_enable(el)
        el.addEventListener('change', (e) => {
          payment_method_other_text_enable(el)
        })
      })

      Array.from(document.getElementsByClassName('setting_bank_account')).forEach(el => {
        Array.from(document.getElementsByClassName('bank_account_area')).forEach(area => {
          area.style.display = el.checked == true ? "" : "none"
        })
        el.addEventListener('change', (e) => {
          Array.from(document.getElementsByClassName('bank_account_area')).forEach(area => {
            area.style.display = el.checked == true ? "" : "none"
          })
        })
      })

      Array.from(document.getElementsByClassName('upload_delete')).forEach(el => {
        el.addEventListener('click', (e) => {
          el.parentNode.parentNode.style.display = "none"
        })
      })

      const store_id = document.getElementById('store_id').value
      let token = ''
      Array.from(document.getElementsByTagName('meta')).forEach(meta => {
        if (meta.name != 'csrf-token') return
        token = meta.content
      })

      commentLoad(store_id, token, 30)
      commentPost(store_id, token)

      Array.from(document.getElementsByClassName('comment-reload')).forEach(el => {
        el.addEventListener('click', (e) => {
          commentLoad(store_id, token, 30)
        })
      })

      const form = document.querySelector('form[data="update"]');
      form.addEventListener('submit', (event) => {
        // Salesforce ID 未入力時で保存時に警告表示
        const account_id = document.getElementById('store_sf_account_id').value
        const opportunity_id = document.getElementById('store_sf_opportunity_id').value
        const contact_id = document.getElementById('store_sf_contact_id').value
        const message = [
          'Salesforce ID が入力されていません。',
          'このまま保存すると、Salesforce 上に新しいデータが追加されます。',
          '',
          '処理を続行しますか？',
        ].join("\n")
        if (!(account_id && opportunity_id && contact_id) && !window.confirm(message)) {
          event.stopPropagation()
          event.preventDefault()
          return false
        }

        // Clear disabled attributes in 連携先 before submit.
        const cardCompanyElms = document.getElementsByClassName('parent_store_card_company');
        for(let i = 0; i < cardCompanyElms.length; i++) {
          cardCompanyElms[i].disabled = false;
        }
        const eMoneyCompanyElms = document.getElementsByClassName('parent_store_e_money_company');
        for(let i = 0; i < eMoneyCompanyElms.length; i++) {
          eMoneyCompanyElms[i].disabled = false;
        }
        const qrCodeCompanyElms = document.getElementsByClassName('parent_store_qr_code_company');
        for(let i = 0; i < qrCodeCompanyElms.length; i++) {
          qrCodeCompanyElms[i].disabled = false;
        }
        const directDebitCompanyElms = document.getElementsByClassName('parent_store_direct_debit_company');
        for(let i = 0; i < directDebitCompanyElms.length; i++) {
          directDebitCompanyElms[i].disabled = false;
        }
        const ratioElms = document.getElementsByClassName('parent_store_ratio');
        for(let i = 0; i < ratioElms.length; i++) {
          ratioElms[i].disabled = false;
        }
        const agencyRatioElms = document.getElementsByClassName('parent_store_agency_sales_ratio');
        for(let i = 0; i < agencyRatioElms.length; i++) {
          agencyRatioElms[i].disabled = false;
        }
        const wholesaleRatioElms = document.getElementsByClassName('parent_store_wholesale_ratio');
        for(let i = 0; i < wholesaleRatioElms.length; i++) {
          wholesaleRatioElms[i].disabled = false;
        }
      });

      function card_information_retention_status(element) {
        const date = document.getElementById('store_common_store_attributes_store_examination_attributes_scheduled_non_retention_date_1i');
        const month = document.getElementById('store_common_store_attributes_store_examination_attributes_scheduled_non_retention_date_2i');
        const day = document.getElementById('store_common_store_attributes_store_examination_attributes_scheduled_non_retention_date_3i');

        if (element.value === '3') {
          date.disabled = false;
          month.disabled = false;
          day.disabled = false;
        } else {
          date.disabled = true;
          month.disabled = true;
          day.disabled = true;
        }
      }

      Array.from(document.getElementsByName('store[common_store_attributes][store_examination_attributes][card_information_retention_status]')).forEach(element => {
        window.addEventListener('load', (e) => {
          card_information_retention_status(element)
        })

        element.addEventListener('change', (e) => {
          card_information_retention_status(element)
        })
      })

      function pcidss_compliance_status(element) {
        const date = document.getElementById('store_common_store_attributes_store_examination_attributes_pcidss_compliant_date_1i');
          const month = document.getElementById('store_common_store_attributes_store_examination_attributes_pcidss_compliant_date_2i');
          const day = document.getElementById('store_common_store_attributes_store_examination_attributes_pcidss_compliant_date_3i');

        if (element.value === '2') {
          date.disabled = false;
          month.disabled = false;
          day.disabled = false;
        } else {
          date.disabled = true;
          month.disabled = true;
          day.disabled = true;
        }
      }

      Array.from(document.getElementsByName('store[common_store_attributes][store_examination_attributes][pcidss_compliance_status]')).forEach(element => {
        window.addEventListener('load', (e) => {
          pcidss_compliance_status(element)
        })

        element.addEventListener('change', (e) => {
          pcidss_compliance_status(element)
        })
      })

      const rabbitAccountIssuedBtn = document.querySelector(
      ".rabbit-account-issued-btn"
      );
      if (rabbitAccountIssuedBtn) {
      rabbitAccountIssuedBtn.addEventListener("click", (e) => {
        const email = document.getElementById('store_common_store_attributes_email').value;

        if (!confirm(`メールアドレス「${email}」でRabbitアカウントを発行しますか？`)) return;

        const form = document.createElement("form");
        form.action = e.target.dataset.url;
        form.method = "post";
        form.style = "overflow: hidden; width: 0; height: 0;";

        // メールパラメータの追加
        const emailInput = document.createElement("input");
        emailInput.setAttribute("type", "hidden");
        emailInput.setAttribute("name", "email");
        emailInput.setAttribute("value", email);
        form.appendChild(emailInput);

        const token = document.createElement("input");
        token.setAttribute("type", "hidden");
        token.setAttribute(
          "name",
          document.querySelector("meta[name=csrf-param][content]").content
        );
        token.setAttribute(
          "value",
          document.querySelector("meta[name=csrf-token][content]").content
        );
        form.appendChild(token);

        document.body.appendChild(form);
        form.submit();
      });
      }

      // 金額にカンマを付けるライブラリをインポート
      new AmountFormatter().Run();
    })
  },

  show() {
    document.addEventListener('DOMContentLoaded', () => {

      document.getElementById("submitter").innerHTML = "";

      Array.from(document.getElementsByTagName("input")).forEach(el => {
        if(el.type === "hidden") return;
        if(el.type === "radio") {
          if(!el.checked) el.disabled = "disabled"
        }
        el.readOnly = true
      })

      Array.from(document.getElementsByTagName("select")).forEach(el => {
        Array.from(el.getElementsByTagName("option")).forEach(option => {
          if(!option.selected) option.disabled = "disabled"
        })
      })

      Array.from(document.getElementsByTagName("button")).forEach(el => {
        el.style = "display:none"
      })

      Array.from(document.getElementsByTagName("textarea")).forEach(el => {
        if(el.id === "term_of_service") return
        el.readOnly = true
      })
      Array.from(document.getElementsByClassName("comment-input")).forEach(el => {
        el.readOnly = false
      })

      commentLoad(store_id, token, 30)
      commentPost(store_id, token)

      Array.from(document.getElementsByClassName('comment-reload')).forEach(el => {
        el.addEventListener('click', (e) => {
          commentLoad(store_id, token, 30)
        })
      })

    })
  }

}
